// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  planterId: __t.u64().primaryKey().name("planter_id"),
  structureId: __t.u64().name("structure_id"),
  key: __t.string(),
  familyKey: __t.string().name("family_key"),
  name: __t.string(),
  statsJson: __t.string().name("stats_json"),
  spawnId: __t.u64().name("spawn_id"),
  plantedAt: __t.timestamp().name("planted_at"),
  readyAt: __t.timestamp().name("ready_at"),
});
